export default {
  SET_AFFECTED_ROLE: 'SET_AFFECTED_ROLE',

}
